import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { CognitoService } from './cognito.service';
import { UsersService } from '../pages/users/users.service';
import { APIService, GetUserQuery, User } from '../app-sync.service';
import { CognitoUser } from '../shared/interfaces/cognito-user';
import { FeedbacksService } from '../shared/feedbacks/feedbacks.service';

@Injectable({
  providedIn: 'root',
})
export class BusinessGuard implements CanActivate {
  activeCognitoUser: CognitoUser | null = null;
  activeUser: User;
  constructor(
    private usersService: UsersService,
    private api: APIService,
    private feedbacksService: FeedbacksService,
    private cognitoService: CognitoService,
    private router: Router
  ) {
    this.activeUser = this.usersService.getActiveUser();
  }
  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean | UrlTree> {
    const business = route.paramMap.get('business');
    console.log('BUSINES GUARD BUSINESS:', business);
    if (!business) {
      return true;
    }

    try {
      // intentar obtener usuario desde servicio primero
      this.activeUser = this.usersService.getActiveUser();

      // si aún no existe → cargarlo
      if (!this.activeUser.hasAccessTo) {
        const cognitoUser: any = await this.cognitoService.getUser();
        this.activeCognitoUser = cognitoUser.attributes;
        console.log('cognito email:', this.activeCognitoUser!.email);
        const user: GetUserQuery = await this.api.GetUser(
          this.activeCognitoUser!.email
        );

        this.usersService.setActiveUser(user);
        this.activeUser = user;
      }

      const businessList: string[] = this.activeUser.hasAccessTo!.split(',');

      const hasAccess = businessList.includes(business.toUpperCase());

      if (!hasAccess) {
        return this.router.createUrlTree(['/home']);
      }

      // guardar active business
      this.usersService.business.next(business);

      return true;
    } catch (error: any) {
      console.log(error);
      this.feedbacksService.showErrorFeedbacks(
        error,
        `Error al cargar datos del usuario`
      );

      return this.router.createUrlTree(['/home']);
    }
  }
}
